import { render } from "./Edit.vue?vue&type=template&id=3eed51da"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/media/alvian/New Volume14/project/vue js/sfa-nepal-web-report/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__